import React from 'react';
import { Link } from 'gatsby';
import VideoPlayer from '../VideoPlayer';
import Clouds from '../../assets/images/clouds.svg';

/**
 * Intro section: breadcrumb, title, description, optional top video.
 */
export function InteractiveLearningIntro({
  title,
  description,
  topVideo,
  topYoutubeVideo,
}) {
  const hasVideo = topVideo?.video?.streamingUrl || topYoutubeVideo;

  return (
    <div>
      <div className="container">
        <div className="interactive-intro">
          <div className="content-block">
            <Link className="brainteaser-breadcrumb" to="/interactive-learning">
              Interactive Learning
            </Link>
            <h1>{title}</h1>
            <br />
            {description && (
              <div dangerouslySetInnerHTML={{ __html: description }} />
            )}
          </div>
          {hasVideo && (
            <div style={{ marginLeft: '1rem' }}>
              <VideoPlayer
                src={topYoutubeVideo ?? topVideo.video.streamingUrl}
                width={500}
              />
            </div>
          )}
        </div>
      </div>
      <img src={Clouds} alt="Clouds" className="pattern-left" />
    </div>
  );
}
